var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"web-render"}},[(_vm.url != '')?[_c('iframe',{attrs:{"src":_vm.url,"width":"100%","sandbox":"allow-forms allow-scripts allow-same-origin","height":"100%","frameborder":"0"}})]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }